<template>
    <modal name="multilang-modal" :width="315" :height="200" :adaptive="true" :styles="'background-color: rgba(0, 0, 0, 0);box-shadow: none;'" @before-open="loadLang" class="relative">
        <div class="select-language-content">
            <span class="title">Select language</span>
            <div @click="changeMultilang('id')" class="flex flex-1 flex-row indonesia" :class="{'active': currLanguage === 'id'}">
                <div class="flex flex-1 flex-row">
                    <svg v-if="currLanguage === 'id'" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM18.0952 10C18.0952 14.4709 14.4709 18.0952 10 18.0952C5.52912 18.0952 1.90476 14.4709 1.90476 10C1.90476 5.52912 5.52912 1.90476 10 1.90476C14.4709 1.90476 18.0952 5.52912 18.0952 10ZM10 16.1905C13.4189 16.1905 16.1905 13.4189 16.1905 10C16.1905 6.58109 13.4189 3.80952 10 3.80952C6.58109 3.80952 3.80952 6.58109 3.80952 10C3.80952 13.4189 6.58109 16.1905 10 16.1905Z" fill="white"/>
                    </svg>
                    <svg v-if="currLanguage !== 'id'" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="10" cy="10" r="9" stroke="#7A869A" stroke-width="2"/>
                    </svg>
                    <span :class="{'active': currLanguage === 'id'}">Indonesia</span>
                </div>
                <img src="../assets/image/flag-ind.png" alt="">
            </div>
            <div @click="changeMultilang('en')" class="flex flex-row english" :class="{'active': currLanguage === 'en'}">
                <div class="flex flex-row">
                    <svg v-if="currLanguage !== 'en'" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="10" cy="10" r="9" stroke="#7A869A" stroke-width="2"/>
                    </svg>
                    <svg v-if="currLanguage === 'en'" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM18.0952 10C18.0952 14.4709 14.4709 18.0952 10 18.0952C5.52912 18.0952 1.90476 14.4709 1.90476 10C1.90476 5.52912 5.52912 1.90476 10 1.90476C14.4709 1.90476 18.0952 5.52912 18.0952 10ZM10 16.1905C13.4189 16.1905 16.1905 13.4189 16.1905 10C16.1905 6.58109 13.4189 3.80952 10 3.80952C6.58109 3.80952 3.80952 6.58109 3.80952 10C3.80952 13.4189 6.58109 16.1905 10 16.1905Z" fill="white"/>
                    </svg>
                    <span :class="{'active': currLanguage === 'en'}">English</span>
                </div>
                <img src="../assets/image/flag-eng.png" alt="">
            </div>
        </div>
    </modal>
</template>

<script>
    export default {
        name: "MultilangModal",
        data: function () {
            return {
                currLanguage: 'en'
            }
        },
        mounted() {
            this.getBanner();
        },
        methods: {
            loadLang: function() {
                this.currLanguage = localStorage.getItem('lang');
            },
            changeMultilang: function(param) {
                this.currLanguage = param;
                localStorage.setItem('lang', this.currLanguage);
                // this.closeModal();
                window.location.reload();
            },
            handleBanner: function (state) {
                
                if (state === 'plus') {
                    if (this.step === 3) {
                        this.step = 1;
                        return;
                    }
                    else if (this.step === 2 && !this.list_banner.banner_3.isActive) {
                        this.step = 1;
                        return;
                    }
                    this.step = this.step + 1; 
                }
                if (state === 'minus') {
                    if (this.step === 1) {
                        this.step = 3;
                        return;
                    }
                    this.step = this.step - 1; 
                }
                
            },
            getBanner: function () {
                this.isLoading = true
                const axios = require('axios')

                //'this' tidak bisa dipanggil di dalam scope dalam, sehingga perlu di deklarasi menggunakan variable lain dalam scope function
                let main = this
                let url = `https://cms.ocaindonesia.co.id/wp-json/wp/v2/oca_dtp?slug=banner-promotion`
                axios.get(url)
                    .then(function (response) {
                        let banner = response.data[0].acf;

                        main.list_banner = {
                            banner_1: {
                                img: banner.banner_1_img,
                                imgMobile: banner.banner_1_img_mobile,
                                url: banner.banner_1_url,
                                isActive: banner.banner_1_status,
                            },
                            banner_2: {
                                img: banner.banner_2_img,
                                imgMobile: banner.banner_2_img_mobile,
                                url: banner.banner_2_url,
                                isActive: banner.banner_2_status,
                            },
                            banner_3: {
                                img: banner.banner_3_img,
                                imgMobile: banner.banner_3_img_mobile,
                                url: banner.banner_3_url,
                                isActive: banner.banner_3_status,
                            },
                        }
                    })
            },
            closeModal: function () {
                this.$modal.hide("multilang-modal")
            }
        },
    }
</script>

<style scoped>
    div.v--modal-box.v--modal {
        background-color: rgba(0, 0, 0, 0) !important;
    }

    .bxs-arrow-left {
        position: absolute;
        top: 50%;
        left: 0;
        width: 32px;
        height: 32px;
        z-index: 20;
        cursor: pointer;
    }

    .select-language-content {
        display: flex;
        flex-direction: column;
        background: #FFFFFF;
        border-radius: 12px;
        padding: 16px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
    }

    .select-language-content .title {
        font-weight: 600;
        font-size: 14px;
        line-height: 17px;
        color: #000000;
        text-align: center;
    }

    .select-language-content .indonesia {
        margin-top: 24px;
        padding: 16px;
        justify-content: space-between;
        border-radius: 12px;
    }

    .select-language-content .active{
        background: #E81255 !important;
    }

    .select-language-content .indonesia span {
        align-self: center;
        font-weight: 300;
        font-size: 16px;
        line-height: 19px;
        color: #313131;
        margin-left: 12px;
    }

    .select-language-content .indonesia .active {
        color: #FFFFFF !important;
    }

    .select-language-content .indonesia img {
        align-self: center;
    }


    .select-language-content .english {
        margin-top: 24px;
        padding: 16px;
        justify-content: space-between;
    }

    .select-language-content .english span {
        align-self: center;
        font-weight: 300;
        font-size: 16px;
        line-height: 19px;
        color: #313131;
        margin-left: 12px;
    }

    .select-language-content .english .active {
        color: #FFFFFF !important;
    }

    .select-language-content .english img {
        align-self: center;
    }

</style>